import { useCallback } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { configureILevel, fetchILevelConfig } from '../../../services/queries/MaggieIntegrationsQueries';
import { ILevelFormValues } from './iLevelConfig.schema';

export function useILevelConfigActions() {
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery({
    queryKey: ['ilevel-config'],
    queryFn: fetchILevelConfig,
  });

  const mutation = useMutation({
    mutationFn: configureILevel,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ilevel-config'] });
      queryClient.invalidateQueries({ queryKey: ['integrations'] });
    },
  });

  const config = data ?? null;
  const isConnected = config?.isConnected ?? false;

  const saveConfig = useCallback(
    async (values: ILevelFormValues) => {
      const result = await mutation.mutateAsync({
        clientId: values.clientId.trim(),
        clientSecret: values.clientSecret.trim() || undefined,
      });
      return result;
    },
    [mutation]
  );

  const resetConfig = useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: ['ilevel-config'] });
  }, [queryClient]);

  return { config, isConnected, isLoading, saveConfig, resetConfig };
}
